module.exports = __webpack_public_path__ + "static/media/refrigerator.27900ed5.svg";